import PuffLoader from 'react-spinners/PuffLoader';

export default function Loader (): JSX.Element {
    return (
        <span className="loading">
            <PuffLoader color="#262958" size="70px" />
        </span>
    );
}
